export default [
  {
    label: "Brand",
    name: "brand",
    type: "text",
    required: true,
  },
  {
    label: "Model",
    name: "model",
    type: "text",
    required: true,
  },
  {
    label: "With Humidifier",
    name: "withHumidifier",
    type: "select",
    options: ["Yes", "No"],
    required: true,
  },
  {
    label: "Price",
    name: "price",
    type: "text",
    required: true,
  },
  {
    label: "Humidifier Price",
    name: "humidifierPrice",
    type: "text",
    required: true,
  },
  {
    label: "Tube Price",
    name: "tubePrice",
    type: "text",
    required: true,
  },
  {
    label: "Rental Price",
    name: "rentalPrice",
    type: "text",
    required: true,
  },
  {
    label: "Status",
    name: "IsActive",
    type: "select",
    options: ["Active", "Inactive"],
  },
];
